import { useSyncExternalStore } from 'react';
import { getPublicAppSettingsSnapshot, subscribePublicAppSettings } from '../services/publicAppSettingsStore';

/** 全画面共通の公開設定を購読し、管理者の保存結果へ自動追従する。 */
const usePublicAppSettings = () => useSyncExternalStore(
  subscribePublicAppSettings,
  getPublicAppSettingsSnapshot,
  getPublicAppSettingsSnapshot,
);

export default usePublicAppSettings;
